module.exports = __webpack_public_path__ + "static/Grafika8@2x-dc2d488e027108cb133a3deb8c684a93.png";